// extracted by mini-css-extract-plugin
module.exports = {"propertyColor":"PropertyColor_propertyColor__l5meS","selected":"PropertyColor_selected__284F5"};